import {
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  MultiSelect,
  TextInput,
  Title
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconBuilding,
  IconBuildingSkyscraper,
  IconCalendar,
  IconFileTypeCsv,
  IconSearch,
  IconTruck
} from "@tabler/icons-react";
import dayjs from "dayjs";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { BASE_API_DELIVERY } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  getMasterOrgSelect
} from "../../../service/getSelectApi";

interface IStorageReportOrder {
  maPxk?: string | null;
  maNvkho?: string | null;
  tenNvkho?: string | null;
  ngayCtDh?: string | null;
  soDh?: string | null;
  maVach?: string | null;
  maSp?: string | null;
  tenSp?: string | null;
  giaBan?: number | null;
  ngayXuatBan?: string | null;
  ngayNhapKho?: string | null;
  ngayLuuKhoBan?: number | null;
  ngayNhapMua?: string | null;
  luuKhoMuaHang?: number | null;
  maKh?: string | null;
  tenKh?: string | null;
  sdtKh?: string | null;
  maNvgd?: string | null;
  tenNvgd?: string | null;
  maCn?: string | null;
  tenCn?: string | null;
  maKho?: string | null;
  tenKho?: string | null;
  dienGiai?: string | null;
  dienGiaiCtGoc?: string | null;
  supplier?: string | null;
  giaNhap?: number | null;
}

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const StorageReportOrder = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<IStorageReportOrder[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    MaSps: _searchJson && checkedPinSearch ? _searchJson.MaSps : [],//sản phẩm
    MaCns: _searchJson && checkedPinSearch ? _searchJson.MaCns : [],//chi nhánh
    MaKhos: _searchJson && checkedPinSearch ? _searchJson.MaKhos : [],//kho
    Suppliers: _searchJson && checkedPinSearch ? _searchJson.Suppliers : [],//danh sách nhà cung cấp 
    NgayCtDhTu:
      _searchJson && checkedPinSearch && _searchJson.NgayCtDhTu ? new Date(_searchJson.NgayCtDhTu) : dayjs().subtract(1, 'month').toDate(),
    NgayCtDhDen:
      _searchJson && checkedPinSearch && _searchJson.NgayCtDhDen ? new Date(_searchJson.NgayCtDhDen) : dayjs().toDate(),
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );
  const [dataInvCode, setDataInvCode] = useState<ComboboxItem[]>([]);

  const [searchItem, setSearchItem] = useState<string>("");
  const [debouncedSearchItem] = useDebouncedValue<string>(searchItem, 300);
  const [dataItem, setDataItem] = useState<ComboboxItem[]>([]);
  const [dataMasterOrg, setDataMasterOrg] = useState<ComboboxItem[]>([]);
  const [dataNhvt, setDataNhvt] = useState<ComboboxItem[]>([]);
  const [dataVendorSelect, setDataVendorSelect] = useState<ComboboxItem[]>([]);
  const columns = React.useMemo<MRT_ColumnDef<IStorageReportOrder>[]>(() => [

    { accessorKey: "soDh", header: "Đơn hàng" },
    { accessorKey: "maPxk", header: "Số PXK" },
    {
      accessorKey: "ngayCtDh",
      header: "Ngày CT ĐH",
      Cell: ({ cell }) => {
        const v = cell.getValue<string | null | undefined>();
        if (!v) return "";
        const d = dayjs(v);
        return d.isValid() ? d.format("DD-MM-YYYY HH:mm:ss") : "Invalid date";
      },
    },
    { accessorKey: "maVach", header: "Mã vạch" },
    { accessorKey: "maSp", header: "Mã SP" },
    { accessorKey: "tenSp", header: "Tên SP" },
    {
      accessorKey: "giaBan",
      header: "Giá bán",
      Cell: ({ cell }) =>
        cell.getValue<number | null>() != null
          ? Number(cell.getValue<number | null>()).toLocaleString("vi-VN")
          : "",
    },
    {
      accessorKey: "ngayXuatBan",
      header: "Ngày xuất bán",
      Cell: ({ cell }) => {
        const v = cell.getValue<string | null | undefined>();
        if (!v) return "";
        const d = dayjs(v);
        return d.isValid() ? d.format("DD-MM-YYYY HH:mm:ss") : "Invalid date";
      },
    },
    {
      accessorKey: "ngayNhapKho",
      header: "Ngày nhập kho",
      Cell: ({ cell }) => {
        const v = cell.getValue<string | null | undefined>();
        if (!v) return "";
        const d = dayjs(v);
        return d.isValid() ? d.format("DD-MM-YYYY HH:mm:ss") : "Invalid date";
      },
    },
    {
      accessorKey: "ngayLuuKhoBan",
      header: "Số ngày lưu kho bán",
      Cell: ({ cell }) =>
        cell.getValue<number | null>() != null
          ? String(cell.getValue<number | null>())
          : "",
    },
    {
      accessorKey: "ngayNhapMua",
      header: "Ngày nhập mua",
      Cell: ({ cell }) => {
        const v = cell.getValue<string | null | undefined>();
        if (!v) return "";
        const d = dayjs(v);
        return d.isValid() ? d.format("DD-MM-YYYY HH:mm:ss") : "Invalid date";
      },
    },
    {
      accessorKey: "luuKhoMuaHang",
      header: "Lưu kho mua hàng",
      Cell: ({ cell }) =>
        cell.getValue<number | null>() != null
          ? String(cell.getValue<number | null>())
          : "",
    },
    { accessorKey: "maKh", header: "Mã KH" },
    { accessorKey: "tenKh", header: "Tên KH" },
    { accessorKey: "sdtKh", header: "SĐT KH" },
    { accessorKey: "maNvkho", header: "Mã NV Kho" },
    { accessorKey: "tenNvkho", header: "Tên NV Kho" },
    { accessorKey: "maNvgd", header: "Mã NVGD" },
    { accessorKey: "tenNvgd", header: "Tên NVGD" },
    { accessorKey: "maCn", header: "Mã CN" },
    { accessorKey: "tenCn", header: "Chi nhánh" },
    { accessorKey: "maKho", header: "Mã kho" },
    { accessorKey: "tenKho", header: "Tên kho" },
    { accessorKey: "dienGiai", header: "Diễn giải" },
    { accessorKey: "dienGiaiCtGoc", header: "Diễn giải CT gốc" },
    { accessorKey: "supplier", header: "Nhà cung cấp" },
    {
      accessorKey: "giaNhap",
      header: "Giá nhập",
      Cell: ({ cell }) =>
        cell.getValue<number | null>() != null
          ? Number(cell.getValue<number | null>()).toLocaleString("vi-VN")
          : "",
    },
  ], []);
  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/MvBcLuuKhoBanHang/get-list?Skip=${pagination.pageIndex * pagination.pageSize
        }&Take=${pagination.pageSize}`;

      if (keySearch && keySearch.length > 0) {
        url += `&KeySearch=${keySearch.trim()}`;
      }

      // Add array filters
      if (search.MaSps && search.MaSps.length > 0) {
        search.MaSps.forEach((maSp: string) => {
          url += `&MaSps=${maSp}`;
        });
      }
      if (search.MaCns && search.MaCns.length > 0) {
        search.MaCns.forEach((maCn: string) => {
          url += `&MaCns=${maCn}`;
        });
      }
      if (search.MaKhos && search.MaKhos.length > 0) {
        search.MaKhos.forEach((idKho: string) => {
          url += `&MaKhos=${idKho}`;
        });
      }
      if (search.Suppliers && search.Suppliers.length > 0) {
        search.Suppliers.forEach((supplier: string) => {
          url += `&Suppliers=${supplier}`;
        });
      }

      // Add date filters
      if (search.NgayCtDhTu) {
        url += `&NgayCtDhTu=${search.NgayCtDhTu.toISOString()}`;
      }
      if (search.NgayCtDhDen) {
        url += `&NgayCtDhDen=${search.NgayCtDhDen.toISOString()}`;
      }
      const res = await repositoryDelivery.get<
        MessageResponse<IStorageReportOrder[]>
      >(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        })
      );
    }
  };

  const exportDataExcel = async () => {
    console.log("search", search);
    open();
    try {
      const payload: any = {
        KeySearch: (keySearch || "").trim(),
        MaSps:
          Array.isArray(search.MaSps) && search.MaSps.length > 0
            ? search.MaSps
            : null,
        MaCns:
          search.MaCns && search.MaCns.length > 0
            ? search.MaCns.map((v: any) => (v === null ? null : (v)))
            : null,
        MaKhos:
          search.MaKhos && search.MaKhos.length > 0
            ? search.MaKhos.map((v: any) => (v === null ? null : (v)))
            : null,
        Suppliers:
          search.Suppliers && search.Suppliers.length > 0
            ? search.Suppliers.map((v: any) => (v === null ? null : (v)))
            : null,
        NgayCtDhTu: search.NgayCtDhTu
          ? new Date(search.NgayCtDhTu).toISOString()
          : null,
        NgayCtDhDen: search.NgayCtDhDen
          ? new Date(search.NgayCtDhDen).toISOString()
          : null,
      };

      const _url = BASE_API_DELIVERY + "/api/v1/MvBcLuuKhoBanHang/export";
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token
            ?.replace(/\"/g, "")
            .replace(/\"/g, "")}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 200) {
        NotificationExtension.Success("Yêu cầu xuất đã vào hàng đợi.");
      } else {
        // read server error text if available
        let text = "";
        try {
          text = await response.text();
          console.error("Export failed response text:", text);
        } catch (e) {
          console.error(e);
        }
        NotificationExtension.Fails("Export Excel thất bại !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const fetchDataItem = async () => {
    let url = "api/v1/TblItem/get-list?Skip=0&Take=50";

    if (searchItem?.length > 0) {
      url += `&ListItemCode=${searchItem?.toUpperCase()}`;
    }

    const response = await repositoryPos.get<MessageResponse<any>>(url);

    if (response && response.success) {
      const transformedData = response.data
        ?.filter((item: any) => item.itemCode && item.itemName)
        .map((item: any) => ({
          label: item.itemCode + " - " + item.itemName,
          value: item.itemCode,
        }));
      const uniqueData = Array.from(
        new Set(transformedData.map((item: any) => item.value))
      ).map((value) =>
        transformedData.find((item: any) => item.value === value)
      );
      setDataItem(uniqueData);
    }
  };

  const fetchDataMasterOrg = async () => {
    const res = await getMasterOrgSelect();
    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.att1),
        }));
      setDataMasterOrg(data);
    }
  };
  const fetchDataInvCode = async () => {
    try {
      const response = await repositoryPos.get<MessageResponse<any>>(
        `/api/v1/TblDmInventory/get-all?checkAuth=true&select=true`
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((i: any) => i.att1 && i.text && i.att1 !== "-1")
          ?.map((item: any) => ({
            label: item.text?.toString(),
            value: String(item.att1),
          }));

        setDataInvCode(transformedData);
      }
    } catch (error) {
      console.error("Error fetching inventory data:", error);
    }
  };
  const fetchDataNhvt = async () => {
    try {
      const url = "/api/v1/TblCatSegment4d/get-list?Skip=0&Take=100";
      const res = await repositoryPos.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const data = res.data
          ?.filter((item: any) => item.codeString && item.name)
          ?.map((item: any) => ({
            label: `${item.codeString} - ${item.name}`,
            value: item.codeString,
          }));
        setDataNhvt(data);
      }
    } catch (error) {
      console.error("Error fetching warehouse group data:", error);
    }
  };

  const getDataVendorSelect = async () => {
    const getData = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblVendor/get-all"
    );

    if (getData && getData?.success) {
      const result = getData.data;
      setDataVendorSelect(
        result
          ?.filter(
            (item: any) => item.vendorName != null && item.vendorCode != null
          )
          ?.map((item: any) => ({
            value: item.vendorCode,
            label: `${item.vendorCode} - ${item.vendorName}`,
          }))
      );
    }
  };


  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    fetchDataMasterOrg();
    fetchDataNhvt();
    getDataVendorSelect();
    fetchDataInvCode();
  }, []);

  useEffect(() => {
    fetchDataItem();
  }, [debouncedSearchItem]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningWeighingReport"
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
        left: ["mrt-row-select", "mrt-row-numbers"],
        right: ["enforcement", "action"],
      }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningWeighingReport",
      JSON.stringify(columnPinning)
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.soDh?.toString() || Math.random().toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            <Button
              leftSection={<IconFileTypeCsv size={16} />}
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Mã vật tư"
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              data={dataItem}
              value={
                search.MaSps && search.MaSps?.length > 0 ? search.MaSps : []
              }
              searchable
              clearable
              onSearchChange={setSearchItem}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "MaSps", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              leftSection={<IconBuildingSkyscraper color="#15aabf" />}
              data={dataMasterOrg}
              value={
                search?.MaCns && search?.MaCns.length > 0 ? search?.MaCns : []
              }
              searchable
              clearable
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "MaCns", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Kho"
              leftSection={<IconBuilding size={20} color="#15aabf" />}
              data={dataInvCode}
              value={
                search?.MaKhos && search?.MaKhos.length > 0
                  ? search?.MaKhos
                  : []
              }
              searchable
              clearable
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
              onChange={(e) =>
                changeSearchValue(e ? e : [], "MaKhos", setSearch)
              }
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Nhà cung cấp"
              leftSection={<IconTruck size={20} color="#15aabf" />}
              data={dataVendorSelect}
              value={
                search.Suppliers && search.Suppliers?.length > 0 ? search.Suppliers : []
              }
              searchable
              clearable
              nothingFoundMessage="Không tìm thấy dữ liệu !"
              onChange={(e) => {
                changeSearchValue(e ? e : [], "Suppliers", setSearch);
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              placeholder="Ngày ct đơn hàng từ"
              leftSection={<IconCalendar size={20} color="#15aabf" />}
              value={
                search.NgayCtDhTu ? new Date(search.NgayCtDhTu) : null
              }
              locale="vi"
              valueFormat="DD/MM/YYYY"
              onChange={(date) =>
                setSearch((prev: any) => ({ ...prev, NgayCtDhTu: date }))
              }
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              placeholder="Ngày ct đơn hàng đến"
              leftSection={<IconCalendar size={20} color="#15aabf" />}
              value={
                search.NgayCtDhDen ? new Date(search.NgayCtDhDen) : null
              }
              onChange={(date) =>
                setSearch((prev: any) => ({ ...prev, NgayCtDhDen: date }))
              }
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default StorageReportOrder;
